const $ = window.jQuery;
import range from "shared/util/range";

Ok.IncognitoCarousel = {
	init() {
		this.Parent = IncognitoModal;
		this.Dom = {
			modal: this.Parent.Dom.modal,
		};

		this.Dom.carousel = this.Dom.modal.find(".incognito-modal-carousel");
		this.Dom.nav = this.Dom.modal.find(".incognito-modal-carousel-nav");
		this.Dom.buttons = this.Dom.modal.find(".incognito-modal-carousel-nav-button");

		this.autopan_disabled = true;
		this.autopan = true;

		this.slidecount = this.Dom.carousel.find(".incognito-modal-slide").length;

		this.current = 0;

		// pan to the first slide (so it lights up the nav button)
		this.pan(this.Dom.buttons.first());

		this.listen();

		// autopan every 5 seconds
		this.autopanner = setInterval(this.pan.bind(this), 5000);
	},

	listen() {
		this.Dom.buttons.on("click tap", (ev) => {
			const target = $(ev.target);
			this.pan(target);
		});

		// don't pan while hovering
		this.Dom.carousel.on("mouseenter", (ev) => {
			this.autopan = false;
		});
		this.Dom.carousel.on("mouseleave", (ev) => {
			this.autopan = true;
		});
		this.Dom.nav.on("mouseenter", (ev) => {
			this.autopan = false;
		});
		this.Dom.nav.on("mouseleave", (ev) => {
			this.autopan = true;
		});
	},

	getClass(num) {
		return `incognito-modal-slide-${num}`;
	},

	pan(button) {
		let newslide;

		if (button != null && button.length) {
			newslide = button.data("index");
		} else {
			// autopan the next one.
			// don't do this if we're not set to autopan.
			if (!this.autopan || this.autopan_disabled) {
				return;
			}

			newslide = (this.current + 1) % this.slidecount;
		}

		const classes = range(0, this.slidecount).map(this.getClass).join(" ");

		this.Dom.nav.removeClass(classes).addClass(this.getClass(newslide));
		this.Dom.carousel.removeClass(classes).addClass(this.getClass(newslide));

		this.current = newslide;
	},

	close() {
		clearTimeout(this.autopanner);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/incognito/carousel.js